import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import WinPayTiles from './WinPayTiles';
import NoWincarddata from "./WinPayNoImplementation";

const WINPayCard = () => {
  const [payCards, setPayCards] = useState([]);
  const [error, setError] = useState("");
  const token = localStorage.getItem("AccessToken");
  const contract = useSelector((state) => state.userData);
  const memberID = contract.userData.MemberID;
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const contractData = useSelector((state) => state.userData);
  const [totalRewards, setTotalRewards] = useState(0);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const cardType = location.state?.cardType || 'benefit'; // fallback

  useEffect(() => {
  const fetchPayCards = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        Endpoints.LoadWinCardDetails,
        {
          _Params: JSON.stringify({
            MemberID: memberID,
            Contract: contract.userData.ContractIdentified,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            EmailID: contract.userData.EmailID,
          }),
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const allCards = response.data || [];

      if (!allCards || allCards.length === 0) {
        // 🔥 Redirect to no implementation page if no data
        navigate('/pay-noimplementation', { replace: true });
        return;
      }

      const filteredCards = allCards.filter(card =>
        cardType === 'benefit'
          ? card.FormattedAuthNo && card.FormattedAuthNo.trim() !== ''
          : !card.FormattedAuthNo || card.FormattedAuthNo.trim() === ''
      );

      setPayCards(filteredCards);
    } catch (error) {
      setError(t('failedtoloadwincards'));
    } finally {
      setLoading(false);
    }
  };

  fetchPayCards();

}, [contract.userData.ContractIdentified, memberID, token, cardType, t, navigate]);

  const navigateToCardDetails = (card) => {
    navigate("/card-details", {
      state: {
        CPTCodeDesc: card.CPTCodeDesc,
        AuthorizationNumber: card.FormattedAuthNo,
        RequestedFromToDate: `${card.RequestedFromDate} - ${card.RequestedToDate}`,
        WINCardURL: card.WINCardURL,
        RequestedFromDate: card.RequestedFromDate,
        ApprovedAmount: card.ApprovedAmount,
        cardType,
      },
    });
  };

  // Extract redeem code from WINCardURL
  const getRedeemCode = (WINCardURL) => {
    try {
      const url = new URL(WINCardURL);
      const externalRequestorId = url.searchParams.get("external_requestor_id");
      return externalRequestorId ? externalRequestorId.substring(0, 8) : "";
    } catch (e) {
      return "";
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      {payCards.length > 0 ? (
        <>
          <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
              <span>
                <i className="bi bi-chevron-left"></i>
                {t('Back')}
              </span>
            </button>
            <h2 className="page-heading">
              {isHighmarkPortal ? "Fertility and Family Building Card" : t('winpaycards')}
            </h2>
          </div>
          <div className="pay-card-container mt-2">
            <table className="table winpay-table">
              {cardType == "benefit" ? (
               <> 
                  <thead className="winpay-table-header">
                    <tr>
                      <th>{t('authno')}</th>
                      <th>{t('servicecodedesc')}</th>
                      <th>{t('requestfromto')}</th>
                      <th>{t('reqamount')}</th>
                      <th>{t('approvedamount')}</th>
                      <th>{t('paymentcurrency')}</th>
                      <th>{t('wincard')}</th>
                    </tr>
                  </thead>
                <tbody>
                  {payCards.map((card, index) => (
                    <tr className="winpay-table-row" key={index}>
                      <td>{card.FormattedAuthNo}</td>
                      <td>{card.CPTCodeDesc}</td>
                      <td>{card.RequestedFromDate} - {card.RequestedToDate}</td>
                      <td>{card.RequestedAmount}</td>
                      <td>{card.ApprovedAmount}</td>
                      <td>{card.Currency || "N/A"}</td>
                      <td>
                        {card.WINCardURL ? (
                          <button
                            className="win-linkbtn-secondary-winpay-gird"
                            onClick={() => navigateToCardDetails(card)}
                          >
                            {t('viewcard')}
                          </button>
                        ) : (
                          "N/A"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
              ) : (
              <>
                <thead className="winpay-table-header">
                <tr>
                  <th>{t('redeemdate')}</th>
                  <th>{t('redeemamount')}</th>
                  <th>{t('paymentcurrency')}</th>
                  <th>{t('redeemcode')}</th>
                  <th>{t('wincard')}</th>
                </tr>
              </thead>
              <tbody>
                {payCards.map((card, index) => (
                  <tr className="winpay-table-row" key={index}>
                    <td>{card.RequestedFromDate}</td>
                    <td>{card.RequestedAmount}</td>
                    <td>{card.Currency || "N/A"}</td>
                    <td>{card.WINCardURL ? getRedeemCode(card.WINCardURL) : "N/A"}</td>
                    <td>
                      {card.WINCardURL ? (
                        <button
                          className="win-linkbtn-secondary-winpay-gird"
                          onClick={() => navigateToCardDetails(card)}
                        >
                          {t('viewcard')}
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
              </>
              )}
            </table>
          
            {cardType == "benefit" ? (<>
              <div className="winpay-mini">
              {payCards.map((card, index) => (
                <div className="win-incentive-mini-reward-card mb-3" key={index}>
                  <div className="win-incentive-mini-reward-card-header">
                    <span>{t("Authorization #")} - {card.FormattedAuthNo}</span>
                  </div>
                  <div>
                    <div className="win-incentive-mini-reward-benefit-card-details">
                    <div className="win-incentive-mini-reward-card-detail">
                      <div className="win-incentive-mini-date-label"><span>{t("Request From Date - To Date")}</span></div>
                      <span className="win-incentive-mini-date">{card.RequestedFromDate} - {card.RequestedToDate}</span>
                    </div>
                    <div className="win-incentive-mini-reward-card-detail">
                      <div className="win-incentive-mini-date-label"><span>{t("Currency")}</span></div>
                      <span className="win-incentive-mini-date">{card.Currency}</span>
                    </div>
                  </div>
                  <div className="win-incentive-mini-reward-benefit-card-details">
                    <div className="win-incentive-mini-reward-card-detail">
                      <div className="win-incentive-mini-date-label"><span>{t("Requested Amount")}</span></div>
                      <span className="win-incentive-mini-date">{card.RequestedAmount}</span>
                    </div>
                    <div className="win-incentive-mini-reward-card-detail">
                      <div className="win-incentive-mini-date-label"><span>{t("Approved Amount")}</span></div>
                      <span className="win-incentive-mini-date">{card.ApprovedAmount}</span>
                    </div>
                  </div>
                  </div>
                {card.WINCardURL && <button className="win-incentive-mini-reward-card-button" onClick={() => navigateToCardDetails(card)}>{t("View my WINCard")}</button>}
              </div>
                ))}
            </div>
            </>) : (
              <>
                <div className="winpay-mini">
              {payCards.map((card, index) => (
                <div className="win-incentive-mini-reward-card mb-3" key={index}>
                  <div className="win-incentive-mini-reward-card-header">
                    <span>{t("Redeem code")} - {card.WINCardURL ? getRedeemCode(card.WINCardURL) : "N/A"}</span>
                  </div>
                  <div className="win-incentive-mini-reward-card-details">
                    <div className="win-incentive-mini-reward-card-detail">
                      <div className="win-incentive-mini-date-label"><span>{t("Redeem Date")}</span></div>
                      <span className="win-incentive-mini-date">{card.RequestedFromDate}</span>
                    </div>
                    <div className="win-incentive-mini-reward-card-detail">
                      <div className="win-incentive-mini-date-label"><span>{t("Redeem Amount")}</span></div>
                      <span className="win-incentive-mini-date">{card.RequestedAmount}</span>
                    </div>
                  </div>
                {card.WINCardURL && <button className="win-incentive-mini-reward-card-button" onClick={() => navigateToCardDetails(card)}>{t("View my WINCard")}</button>}
              </div>
                ))}
            </div>
              </>)}
          </div>
        </>
      ) : (
        <>{!payCards?.length && <NoWincarddata />}</>
      )}
    </>
  );
};

export default WINPayCard;
